/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_Galleries_Files_And_AccInputs */

const en_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos, galleries, files & access credentials delivered instantly to your vault.`)
};

const es_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos, galerías, archivos y credenciales de acceso entregados instantáneamente en tu bóveda.`)
};

const fr_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéos, galeries, fichiers et identifiants d'accès livrés instantanément dans votre coffre-fort.`)
};

const de_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos, Galerien, Dateien & Zugangsdaten werden sofort in deinen Vault geliefert.`)
};

const ja_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ、ギャラリー、ファイル、アクセス認証情報が即座にあなたの保管庫に配信されます。`)
};

const zh_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频、图库、文件和访问凭证将即时发送到您的金库中。`)
};

const ar_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقاطع فيديو، معارض، ملفات وبيانات وصول يتم تسليمها فوراً إلى خزنتك.`)
};

const id_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video, galeri, file, dan kredensial akses dikirim langsung ke Vault Anda.`)
};

const it_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video, gallerie, file e credenziali di accesso consegnati istantaneamente nel tuo vault.`)
};

const ru_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео, галереи, файлы и учетные данные для доступа доставляются мгновенно в ваше хранилище.`)
};

const pt_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeos, galerias, arquivos e credenciais de acesso entregues instantaneamente no seu cofre.`)
};

const ko_videos_galleries_files_and_acc = /** @type {(inputs: Videos_Galleries_Files_And_AccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오, 갤러리, 파일 및 접속 권한이 귀하의 Vault(보관소)로 즉시 전송됩니다.`)
};

/**
* | output |
* | --- |
* | "Videos, galleries, files & access credentials delivered instantly to your vault." |
*
* @param {Videos_Galleries_Files_And_AccInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const videos_galleries_files_and_acc = /** @type {((inputs?: Videos_Galleries_Files_And_AccInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_Galleries_Files_And_AccInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_galleries_files_and_acc(inputs)
	if (locale === "es") return es_videos_galleries_files_and_acc(inputs)
	if (locale === "fr") return fr_videos_galleries_files_and_acc(inputs)
	if (locale === "de") return de_videos_galleries_files_and_acc(inputs)
	if (locale === "ja") return ja_videos_galleries_files_and_acc(inputs)
	if (locale === "zh") return zh_videos_galleries_files_and_acc(inputs)
	if (locale === "ar") return ar_videos_galleries_files_and_acc(inputs)
	if (locale === "id") return id_videos_galleries_files_and_acc(inputs)
	if (locale === "it") return it_videos_galleries_files_and_acc(inputs)
	if (locale === "ru") return ru_videos_galleries_files_and_acc(inputs)
	if (locale === "pt") return pt_videos_galleries_files_and_acc(inputs)
	return ko_videos_galleries_files_and_acc(inputs)
});